<template>
  <vue-scroll class="page-calendar">
    <div
      class="page-header header-accent-gradient card-base card-shadow--small"
    >
      <el-row>
        <h1>Agenda de Tareas</h1>
      </el-row>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Agenda de Tareas</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card v-loading="calendarLoading">
      <el-alert
        v-if="rulesForShowingAlert"
        style="margin-bottom: 10px"
        title="No tiene permiso para editar este calendario, no podrá guardar cambios"
        type="warning"
        center
        show-icon
      >
      </el-alert>

      <!-- Avatar block: main avatar (circle) with name below, small avatar to its right aligned vertically, and calendar title to the right -->
      <el-row style="margin-top: 30px; display: flex; align-items: center">
        <!-- Main avatar + name (left) -->
        <el-col
          :span="6"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-left: 12px;
          "
        >
          <el-avatar
            shape="circle"
            :size="100"
            fit="fill"
            :src="SetResponsibleAvatar"
          ></el-avatar>
          <h6 class="ResponsibleName" style="margin-top: 8px; font-size: 13px">
            {{ SetResponsibleName }}
          </h6>
        </el-col>

        <!-- Calendar title (right) -->
        <el-col
          :span="18"
          style="display: flex; align-items: center; padding-left: 8px"
        >
          <h2
            v-if="currentChosenCalendarID > 0"
            style="margin: 0; padding: 0; text-align: left"
          >
            {{ calendarTitle }}
          </h2>
        </el-col>
      </el-row>

      <!-- (removed duplicate calendar title - kept the title in the row above) -->
      <el-row class="filterMenuRow">
        <div style="position: relative; float: right; margin-bottom: 10px">
          <!-- Employee Dropdown -->
          <!--filtros de calendarios-->
          <el-form
            :inline="true"
            :model="filterForm"
            ref="filterForm"
            label-position="top"
          >
            <el-form-item
              label="Gerencia"
              v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
            >
              <DirectionSelector
                v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
                v-model="DirectionFilter"
                @selection-change="handleChangeDirectionFilter"
              />
            </el-form-item>

            <el-form-item
              label="Departamento"
              v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
            >
              <el-select
                v-model="DepartamentFilter"
                placeholder="Departamento"
                size="mini"
                filterable
                clearable
                @change="handleChangeDeparmentFilter"
              >
                <el-option
                  v-for="item in DepartamentList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Responsable" v-if="employees.length > 0">
              <el-select
                v-if="employees.length > 0"
                v-model="employeeId"
                placeholder="Responsable"
                size="mini"
                filterable
                clearable
                @change="getAgendaByEmployee()"
              >
                <el-option
                  v-for="item in EmployeesFilteredByDirection"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <template #default>
                    <div style="display: flex; align-items: center">
                      <el-avatar
                        v-if="item.Image"
                        style="margin-right: 8px"
                        size="small"
                        :src="item.Image"
                      ></el-avatar>
                      <el-avatar
                        v-else
                        style="margin-right: 8px"
                        size="small"
                        src="/static/images/avatar-2.jpg"
                      ></el-avatar>
                      <span style="color: #8492a6; font-size: 12px">{{
                        item.Name
                      }}</span>
                    </div>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Calendario">
              <el-select
                v-model="currentChosenCalendarID"
                placeholder="Calendario"
                size="mini"
                filterable
                clearable
              >
                <el-option
                  v-for="item in listOfCalendarsForUser"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.ID"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="Responsable">
              <el-select
                v-loading="loading"
                v-model="employeeIdResponsable"
                filterable
                clearable
                size="mini"
                placeholder="Colaborador"
                @change="updateSelectedEmployee"
              >
                <el-option
                  v-for="item in employees"
                  :key="item.EmployeeID"
                  :label="item.Name"
                  :value="item.EmployeeID"
                >
                </el-option>
              </el-select>
            </el-form-item> -->

            <!-- Agenda Type  -->
            <el-form-item
              v-if="
                this.currentUser.DireccionID === 45 ||
                this.currentUser.DireccionID == 49
              "
              label="Tipo de Agenda"
            >
              <el-select
                v-model="agendaType"
                placeholder="Evento"
                size="mini"
                filterable
              >
                <el-option
                  v-for="item in agendaTypeSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- Add calendar button -->
            <el-form-item
              label="Crear"
              v-if="
                this.currentUser.IsSupervisor
                /*
                this.currentUser.PositionID == 16 || //CEO
                this.currentUser.PositionID == 47 || //GERENTE DE TI
                this.currentUser.PositionID == 82 || // GERENTE DE OPERACIONES Y PROYECTOS
                this.currentUser.PositionID == 68 || // GERENTE RRHH
                this.currentUser.PositionID == 79 // GERENTE ADMINISTRATIVA Y FINANCIERA
              */
              "
            >
              <el-button
                size="mini"
                plain
                @click="openCalendarDialog"
                v-if="
                  this.currentUser.IsSupervisor
                  /*
                  this.currentUser.PositionID == 16 || //CEO
                  this.currentUser.PositionID == 47 || //GERENTE DE TI
                  this.currentUser.PositionID == 82 || // GERENTE DE OPERACIONES Y PROYECTOS
                  this.currentUser.PositionID == 68 || // GERENTE RRHH
                  this.currentUser.PositionID == 79 // GERENTE ADMINISTRATIVA Y FINANCIERA
                  */
                "
              >
                ✚</el-button
              >
            </el-form-item>
            <!-- Delete calendar button -->

            <!-- v-if="currentChosenCalendarID > 0" -->
            <el-form-item
              label="Eliminar"
              v-if="
                this.currentUser.PositionID == 16 || //CEO
                this.calendarCreatedBy == this.currentUser.EmployeeId
              "
            >
              <el-button
                class="box"
                type="danger"
                size="mini"
                plain
                @click="openCalendarDeleteDialog"
                :disabled="rulesForDisablingSaveButton"
                v-if="
                  this.currentUser.PositionID == 16 || //CEO
                  this.calendarCreatedBy == this.currentUser.EmployeeId
                "
                ><i class="el-icon-delete"></i
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-row>

      <!-- Calendar -->
      <el-col :span="24" v-if="currentChosenCalendarID > 0">
        <FullCalendar
          ref="fullCalendar"
          :options="config"
          class="calendar-wrap card-base card-shadow--medium"
        />
      </el-col>
      <el-col :span="24" v-else class="text-center">
        <h1>Debe seleccionar un calendario</h1>
      </el-col>
    </el-card>

    <!-- Event Create Dialog -->
    <CalendarEventForm
      ref="form"
      @close-event-dialog="closeEventDialog"
      :form="form"
      :submitMode="submitMode"
      :dialogFormVisible="dialogFormVisible"
      :rulesForDisablingSaveButton="rulesForDisablingSaveButton"
      :rulesForDisablingDelete="rulesForDisablingDelete"
      :eventSelectedIsTask="eventSelectedIsTask"
      :userIsSupervisor="userIsSupervisor"
      :userId="userId"
      :currentlyChosenAgenda="currentlyChosenAgenda"
      :currentChosenCalendarID="currentChosenCalendarID"
    />

    <!-- Calendar Create Dialog -->
    <el-dialog title="Calendario" :visible.sync="calendarFormVisible">
      <el-form
        :inline="true"
        :model="calendarForm"
        ref="calendarForm"
        label-position="top"
        class="form-inline"
      >
        <!-- Fila 1: Título -->
        <el-row>
          <el-col :span="13">
            <el-form-item
              label="Titulo"
              prop="title"
              :rules="[
                {
                  required: true,
                  message: 'El titulo es requerido',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model="calendarForm.title"
                :disabled="eventSelectedIsTask"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Fila 2: Otros campos -->
        <el-row :gutter="10">
          <!-- Gerencia -->
          <el-col :span="6" v-if="IsInRoles([roles.CEO, roles.SuperUsuario])">
            <el-form-item label="Gerencia">
              <DirectionSelector
                v-model="calendarForm.DirectionID"
                @selection-change="handleChangeDirection"
              />
            </el-form-item>
          </el-col>

          <!-- Responsable -->
          <!-- <el-col :span="6">

        <el-form-item label="Responsable">
          <el-select

            v-loading="loading"
            v-model="employeeIdResponsable"
            filterable
            clearable
            size="mini"
            placeholder="Colaborador"
            @change="updateSelectedEmployee"
          >
            <el-option
              v-for="item in EmployeesFilteredByDirectionOnCreatCalendar"
              :key="item.EmployeeID"
              :label="item.Name"
              :value="item.EmployeeID"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col> -->

          <el-col :span="6">
            <el-form-item label="Responsable">
              <el-select
                v-loading="loading"
                v-model="employeeIdResponsable"
                filterable
                clearable
                size="mini"
                placeholder="Colaborador"
                @change="updateSelectedEmployee"
              >
                <el-option
                  v-for="item in EmployeesFilteredByDirectionOnCreatCalendar"
                  :key="item.EmployeeID"
                  :label="item.Name"
                  :value="item.EmployeeID"
                >
                  <template #default>
                    <div style="display: flex; align-items: center">
                      <el-avatar
                        v-if="item.Image"
                        style="margin-right: 8px"
                        size="small"
                        :src="item.Image"
                      ></el-avatar>
                      <el-avatar
                        v-else
                        style="margin-right: 8px"
                        size="small"
                        src="/static/images/avatar-2.jpg"
                      ></el-avatar>
                      <span style="color: #8492a6; font-size: 12px">{{
                        item.Name
                      }}</span>
                    </div>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Tipo Estrategia -->
          <el-col :span="6">
            <el-form-item label="Tipo Estrategia">
              <el-select
                v-model="valueEstrategic"
                placeholder="Tipo Estrategia"
                size="mini"
              >
                <el-option
                  v-for="item in selectEstrategicFiltered"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Perspectiva -->
          <el-col :span="6">
            <el-form-item label="Perspectiva">
              <el-select v-model="valuePerspective" size="mini">
                <el-option
                  v-for="item in selectPerspective"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- Footer -->
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="closeCalendarDialog"
          :disabled="disableBtn"
          v-loading="loading"
          >Cancel</el-button
        >
        <el-button
          type="primary"
          @click="submitCalendar"
          :disabled="disableBtn"
          v-loading="loading"
          >Save</el-button
        >
      </span>
    </el-dialog>

    <!-- Calendar Delete Dialog -->
    <el-dialog
      title="Confirmación de eliminación"
      :visible.sync="calendarDeleteDialogVisible"
      width="30%"
    >
      <span>¿Está seguro/a de que desea eliminar este calendario?</span>
      <br />
      <span>Esta acción no puede ser revertida</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCalendarDeleteDialog" v-loading="loading"
          >Cancelar</el-button
        >
        <el-button
          type="danger"
          @click="handleDeleteCalendar"
          v-loading="loading"
          >Eliminar</el-button
        >
      </span>
    </el-dialog>

    <!-- Calendar Share Drawer -->
    <ShareCalendarDrawer
      :openDrawer="openDrawer"
      :calendarID="currentChosenCalendarID"
      @close-drawer="handleCloseDrawer"
    />
  </vue-scroll>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import allLocales from "@fullcalendar/core/locales-all";
import momentPlugin from "@fullcalendar/moment";

import { formatArrayToElSelect } from "@/utils";
import ShareCalendarDrawer from "@/components/calendar/ShareCalendarMaintenanceDrawer.vue";
import CalendarEventForm from "@/components/calendar/CalendarMaintenanceEventForm .vue";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";

export default {
  name: "Calendar Maintenance",
  components: {
    FullCalendar,
    CalendarEventForm,
    ShareCalendarDrawer,
    DirectionSelector
  },
  data() {
    return {
      disableBtn: false,
      employees: [],
      employeeId: "",
      DirectionFilter: "",
      DepartamentFilter: "",
      DepartamentList: [],
      userId: 0,
      currentChosenCalendarID: undefined,
      loading: false,
      calendarApi: null,
      dialogFormVisible: false,
      submitMode: "", // Will be "Add" or "Edit"
      currentlyChosenAgenda: {},
      employeeIdResponsable: "Seleccione Responsable",
      selectEstrategic: [
        {
          value: 2,
          label: "Estrategico"
        },
        {
          value: 1,
          label: "Operacional"
        }
      ],
      selectPerspective: [
        {
          value: 2,
          label: "Del Cliente"
        },
        {
          value: 1,
          label: "Financiera"
        },
        {
          value: 3,
          label: "Procesos Internos"
        },
        {
          value: 4,
          label: "Desarrollo y Aprendizaje"
        }
      ],
      valueEstrategic: "Seleccione Estrategia",
      valuePerspective: "Seleccione Perspectiva",
      form: {
        title: "",
        description: "",
        allDay: false,
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        agendaType: 23,
        frequency: 6,
        employeeId: "",
        color: "#4a596a",
        Time: 0,
        minutesHours: "h",
        fixed: true
      },
      filterForm: {},
      submitModeOptions: {
        Add: "Agregar",
        Edit: "Editar"
      },
      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#4a596a",
        "#c71585"
      ],

      calendarFormVisible: false,
      CompanyID: "",
      calendarForm: {
        title: "",
        DirectionID: 0
      },
      DirectionID: "",
      DeparmentID: "",
      calendarDeleteDialogVisible: false,
      openDrawer: false,
      legend: false,
      agendaType: 23,
      agendaTypeSelect: [],
      agendaTypeGeneric: [
        {
          value: 23,
          label: "Generico"
        }
      ],
      agendaTypeOptionsOPR: [
        {
          value: 22,
          label: "Mantenimiento de vehiculo"
        }
      ],
      agendaTypeOptionsRRHH: [
        {
          value: 15,
          label: "Plantas"
        },
        {
          value: 16,
          label: "Limpieza Oficinas"
        },
        {
          value: 17,
          label: "Limpieza Techos"
        },
        {
          value: 18,
          label: "Pintura"
        },
        {
          value: 19,
          label: "Planta Electrica"
        },
        {
          value: 20,
          label: "Aire Acondicionado"
        },
        {
          value: 21,
          label: "Puertas"
        }
      ],
      agendaTypeOptions: [
        {
          value: 13,
          label: "Todos"
        },
        {
          value: 0,
          label: "PC"
        },
        {
          value: 1,
          label: "Servidores"
        },
        {
          value: 2,
          label: "Switch"
        },
        {
          value: 3,
          label: "Laptop"
        },
        {
          value: 4,
          label: "Wifi"
        },
        {
          value: 5,
          label: "Velocidad de Internet"
        },
        {
          value: 6,
          label: "Antivirus"
        },
        {
          value: 7,
          label: "Backup Bade de Datos"
        },
        {
          value: 8,
          label: "Aire Data Center"
        },
        {
          value: 9,
          label: "Planta Data Center"
        },
        {
          value: 10,
          label: "Ups Data Center"
        },
        {
          value: 11,
          label: "Pruebas de Internet"
        },
        {
          value: 12,
          label: "Pruebas de Integridad de Datos de Clientes"
        },
        {
          value: 14,
          label: "Vehículos"
        }
      ]
    };
  },
  async created() {
    this.employeeId = this.currentUser.EmployeeId;
    this.DirectionFilter = this.currentUser.DireccionID;
    await this.getDepartamentByDirecion(this.DirectionFilter);
    await this.loadEmployees();
    this.userId = this.currentUser.UserID;
    this.DirectionID = this.$store.state.user.user.DireccionID;
    this.CompanyID = this.$store.state.user.user.CompanySelected;
    // await this.GetPersonalCalendario(this.employeeId); // Creates personal calendar if it doesn't exist
    await this.getAllCalendarsForEmployee({
      employeeID: this.employeeId,
      DirectionID: this.DirectionID,
      CompanyID: this.CompanyID
    });
    // this.setPersonalCalendarAsCurrentlyChosen();
    await this.getAgendaByEmployee();
    this.currentChosenCalendarID = this.firstCalendar;
  },

  mounted() {
    this.changeOptions();
  },
  computed: {
    ...mapGetters("calendarMaintenance", [
      "events",
      "weekendsVisible",
      "eventsAreLoading",
      "tasksAreLoading",
      "firstCalendar",
      "calendarCreatedBy",
      "getCalendarResponsible"
    ]),

    // Calendar configuration
    config() {
      return {
        ...this.configOptions,
        ...this.eventHandlers
      };
    },

    configOptions() {
      return {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          listPlugin,
          interactionPlugin,
          momentPlugin
        ],
        initialView: "dayGridMonth",
        locales: allLocales,
        locale: "es", // the initial locale
        height: "auto",
        firstDay: 1,
        allDaySlot: true,
        slotEventOverlap: true,
        selectable: true,
        selectMirror: true,
        eventTimeFormat: {
          hour: "2-digit", //2-digit, numeric
          minute: "2-digit", //2-digit, numeric
          // second: "2-digit", //2-digit, numeric
          meridiem: true, //lowercase, short, narrow, false (display of AM/PM)
          hour12: false //true, false
        },
        navLinks: true, // can click day/week names to navigate views
        editable: true,
        durationEditable: false,
        dayMaxEventRows: true, // for all non-TimeGrid views # v5
        views: {
          month: {
            dayMaxEventRows: 5
          }
        },
        customButtons: {
          addEvent: {
            text: "Agregar Evento",
            click: this.addEventDialog
          },
          shareCalendar: {
            text: "Compartir",
            click: this.openShareDrawer
          }
        },
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right:
            "dayGridMonth,timeGridWeek,timeGridDay,listWeek addEvent shareCalendar"
        },
        weekends: this.weekendsVisible,
        events: this.$store.getters["calendarMaintenance/events"]
      };
    },
    eventHandlers() {
      return {
        dateClick: this.onDateClick,
        eventClick: this.onEventClick,
        select: this.onDateSelect,
        eventDrop: this.onEventDrop
      };
    },
    calendarTitle() {
      if (this.currentChosenCalendarID) {
        let calendar = this.listOfCalendarsForUser.find(
          (element) => element.ID == this.currentChosenCalendarID
        );
        return calendar ? calendar.Title : "-";
      } else {
        return "-";
      }
    },
    Responsable() {
      if (this.employeeId) {
        let respon = this.EmployeesFilteredByDirection.find(
          (element) => element.value == this.employeeId
        );
        return respon ? respon.label : "-";
      } else {
        return "-";
      }
    },

    // Returns the display name to be shown under the main avatar
    SetResponsibleName() {
      if (this.employeeId) {
        const respon = this.EmployeesFilteredByDirection.find(
          (element) => element.value == this.employeeId
        );
        return respon ? respon.label || "-" : "-";
      }
      return "-";
    },

    // Returns the avatar URL (uses backend 'Image' field if present)
    SetResponsibleAvatar() {
      if (this.employeeId) {
        const respon = this.EmployeesFilteredByDirection.find(
          (element) => element.value == this.employeeId
        );
        if (respon) {
          return respon.Image || respon.image || "/static/images/avatar-2.jpg";
        }
      }
      return "/static/images/avatar-2.jpg";
    },

    listOfCalendarsForUser() {
      return this.$store.getters["calendarMaintenance/calendarsForUser"];
    },
    calendarLoading() {
      return /*this.tasksAreLoading ||*/ this.eventsAreLoading;
    },

    // Settings
    watchingSubordinatesCalendars() {
      // This is when the Employee dropdown is being used
      return this.employeeId != this.currentUser.EmployeeId;
    },
    userIsSupervisor() {
      return this.employees.length > 1; // Explanation: Only supervisor roles get the dropdown, if the dropdown exists then the employees property will have contents
    },
    calendarIsPersonal() {
      let listOfCalendars = this.listOfCalendarsForUser;
      return listOfCalendars.find(
        (cal) => cal.ID === this.currentChosenCalendarID && cal.isPersonal
      );
    },
    userCanEditCalendar() {
      let listOfCalendars = this.listOfCalendarsForUser;
      return listOfCalendars.find((cal) => {
        return cal.ID === this.currentChosenCalendarID && cal.canEdit;
      });
    },
    eventSelectedIsTask() {
      return this.currentlyChosenAgenda.event
        ? this.currentlyChosenAgenda.event.extendedProps.isTask
        : false;
    },

    // Rules and permissions
    rulesForShowingAlert() {
      if (this.currentChosenCalendarID > 0 && this.listOfCalendarsForUser) {
        // Si ya ha cargado la vista
        if (
          (!this.userCanEditCalendar || this.watchingSubordinatesCalendars) &&
          this.getCalendarResponsible === this.currentUser.EmployeeId &&
          this.currentUser.PositionID !== 16
        ) {
          return true;
        }
        if (
          this.getCalendarResponsible === this.currentUser.EmployeeId &&
          this.currentUser.PositionID !== 16
        ) {
          return true;
        }
      }

      return false;
    },
    rulesForDisablingSaveButton() {
      // Can't add or edit Agendas to a calendar that belongs to subordinates
      if (
        this.watchingSubordinatesCalendars &&
        this.getCalendarResponsible === this.currentUser.EmployeeId &&
        this.currentUser.PositionID !== 16
      ) {
        if (!this.eventSelectedIsTask) {
          return true;
        }
      }
      // Non supervisors can't edit tasks
      if (
        this.eventSelectedIsTask &&
        !this.userIsSupervisor &&
        this.getCalendarResponsible === this.currentUser.EmployeeId &&
        this.currentUser.PositionID !== 16
      ) {
        return true;
      }
      // Can't edit if user doesn't have edit permission
      if (
        !this.userCanEditCalendar &&
        this.getCalendarResponsible === this.currentUser.EmployeeId &&
        this.currentUser.PositionID !== 16
      ) {
        return true;
      }
      if (
        this.getCalendarResponsible === this.currentUser.EmployeeId &&
        this.currentUser.PositionID !== 16
      ) {
        return false;
      }

      return false;
    },
    rulesForDisablingDelete() {
      return (
        this.watchingSubordinatesCalendars || // Can't delete elements from the calendar of a subordinate
        this.eventSelectedIsTask || // Can't delete tasks
        this.submitMode === this.submitModeOptions.Add || // Can't delete while adding
        !this.userCanEditCalendar // Can't delete without editing permission
      );
    },
    EmployeesFilteredByDirection() {
      let employeesFiltered = [];
      employeesFiltered = this.employees;
      // .filter(
      //   (employ) =>
      //     employ.DirectionId === this.DirectionFilter
      // );
      /*
      if(this.IsInRoles([this.roles.CEO, this.roles.SuperUsuario])) {
        employeesFiltered = this.employees.filter(
          (employ) => employ.DirectionId === this.DirectionFilter
        );

      }
      else {
        employeesFiltered = this.employees
      }
      */
      return employeesFiltered;
    },
    EmployeesFilteredByDirectionOnCreatCalendar() {
      let employeesFiltered = [];
      employeesFiltered = this.employees.filter(
        (employ) => employ.DirectionId === this.DirectionID
      );

      return employeesFiltered;
    },
    selectEstrategicFiltered() {
      let typeStrategic = [];
      if (this.IsInRoles([this.roles.CEO])) {
        typeStrategic = this.selectEstrategic;
      } else {
        typeStrategic = this.selectEstrategic.filter((st) => st.value === 1);
      }
      return typeStrategic;
    }
  },
  methods: {
    ...mapActions("calendarMaintenance", [
      "create",
      "update",
      "set_weekends_visible",
      "GetPersonalCalendario",
      "initTasks",
      "initTasksGantt",
      "updateTaskInApi",
      "delete",
      "getAllCalendarsForEmployee",
      "GetCalendario",
      "CreateCalendario",
      "DeleteCalendario"
    ]),

    changeOptions() {
      if (this.currentUser.DireccionID == 45) {
        this.agendaTypeSelect = this.agendaTypeOptionsRRHH;
      }
      if (this.currentUser.DireccionID == 28) {
        this.agendaTypeSelect = [
          ...this.agendaTypeOptionsRRHH,
          ...this.agendaTypeOptions,
          ...this.agendaTypeOptionsOPR
        ];
        this.currentUser.PositionID;
      }
      if (this.currentUser.DireccionID == 49) {
        this.agendaTypeSelect = this.agendaTypeOptionsOPR;
      } else {
        this.agendaTypeSelect = this.agendaTypeGeneric;
        //this.agendaType =
      }
    },

    handleChangeDirection(directionId) {
      this.DirectionID = directionId;
      //this.GetCalendario();
    },

    updateSelectedEmployee(employeeId) {
      this.employeeIdResponsable = employeeId;
    },

    closeEventDialog() {
      // this.$refs.form.resetFields();
      this.dialogFormVisible = false;
      this.form = {
        title: "",
        description: "",
        allDay: false,
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        color: "#4a596a",
        agendaType: 0,
        frequency: 6,
        employeeId: "",
        completed: 0,
        evidence: 0,
        startDateMonth: "",
        Time: 0,
        minutesHours: "h",
        fixed: true
      };

      this.GetCalendario({
        calendarioID: this.currentChosenCalendarID,
        agendaType: this.agendaType,
        employeeId: this.employeeId
      });
      if (this.calendarIsPersonal) {
        // If the calendar is personal, get the Tasks of the owner of that calendar
        let calendarCreator = this.listOfCalendarsForUser.find(
          (cal) => cal.ID == this.currentChosenCalendarID
        ).CreatedBy;
        // this.initTasks(calendarCreator);
        this.initTasksGantt(calendarCreator);
      }
    },

    addEventDialog() {
      if (this.userCanEditCalendar || this.userIsSupervisor) {
        this.submitMode = this.submitModeOptions.Add;
        this.currentlyChosenAgenda = {};
        this.dialogFormVisible = true;
      }
    },
    onDateClick(arg) {
      if (this.userCanEditCalendar || this.userIsSupervisor) {
        this.currentlyChosenAgenda = arg;
        this.form.startDate = arg.date;
        this.form.endDate = arg.date;
        this.submitMode = this.submitModeOptions.Add;
        this.dialogFormVisible = true;
      }
    },
    onEventClick(arg) {
      this.currentlyChosenAgenda = arg;
      this.form = {
        title: arg.event.title,
        description: arg.event.extendedProps.description,
        allDay: arg.event.allDay,
        startDate: arg.event.extendedProps.startDate,
        startTime: arg.event.extendedProps.startDate,
        endDate: arg.event.extendedProps.endDate, // "end" was being returned as null so a new endDate prop is being used
        endTime: arg.event.extendedProps.endDate,
        color: arg.event.backgroundColor || "#4a596a",
        agendaType: arg.event.extendedProps.agendaType,
        frequency: arg.event.extendedProps.frequency,
        employeeId: arg.event.extendedProps.employeeId,
        completed: arg.event.extendedProps.completed,
        evidence: arg.event.extendedProps.evidence,
        startDateMonth: arg.event.extendedProps.startDateMonth,
        Time: arg.event.extendedProps.Time,
        minutesHours: arg.event.extendedProps.minutesHours,
        fixed: arg.event.extendedProps.fixed
      };
      this.submitMode = this.submitModeOptions.Edit;
      this.dialogFormVisible = true;
    },
    onEventDrop(arg) {
      this.currentlyChosenAgenda = arg;
      this.form = {
        title: arg.event.title,
        description: arg.event.extendedProps.description,
        allDay: arg.event.allDay,
        startDate: arg.event.extendedProps.startDate,
        startTime: arg.event.extendedProps.startDate,
        endDate: arg.event.start,
        endTime: arg.event.start,
        color: arg.event.backgroundColor || "#4a596a",
        agendaType: arg.event.extendedProps.agendaType,
        frequency: arg.event.extendedProps.frequency,
        employeeId: arg.event.extendedProps.employeeId,
        completed: arg.event.extendedProps.completed,
        startDateMonth: arg.event.extendedProps.startDateMonth,
        evidence: arg.event.extendedProps.evidence,
        Time: arg.event.extendedProps.Time,
        minutesHours: arg.event.extendedProps.minutesHours,
        fixed: arg.event.extendedProps.fixed
      };
      this.submitMode = this.submitModeOptions.Edit;
      this.dialogFormVisible = true;
    },
    onDateSelect(arg) {
      if (this.userCanEditCalendar || this.userIsSupervisor) {
        this.currentlyChosenAgenda = arg;

        this.form.startDate = arg.start;
        this.form.endDate = arg.end;

        this.submitMode = this.submitModeOptions.Add;
        this.dialogFormVisible = true;
      }
    },

    // For the Super User Employee Dropdown
    formatArrayToElSelect,
    async loadEmployees() {
      let params = {
        Employeeid: this.currentUser.EmployeeId,
        CompanySelected: this.currentCompany,
        DepartmentID: this.DepartamentFilter || 0,
        DirectionID: this.DirectionFilter || 0
      };
      const { data } = await this.$http.get(
        "/api/CMI/Objetives/GetUsersObjetivos",
        {
          timeout: 3 * 60 * 1000,
          params
        }
      );
      this.employees = this.formatArrayToElSelect(data, {
        value: "EmployeeID",
        label: "Name",
        directionId: "DirectionId",
        image: "Image",
        DeparmentId: "DeparmentId"
      });
    },
    openCalendarDialog() {
      this.calendarFormVisible = true;
    },
    closeCalendarDialog() {
      this.calendarFormVisible = false;
      this.calendarForm.title = "";
      // this.GetPersonalCalendario(this.employeeId);
      this.getAllCalendarsForEmployee({
        employeeID: this.employeeId,
        DirectionID: this.DirectionID,
        CompanyID: this.CompanyID
      });
      // this.setPersonalCalendarAsCurrentlyChosen();
    },
    async submitCalendar() {
      let calendarCrreationResp = false;
      this.loading = true;
      this.disableBtn = true;
      calendarCrreationResp = await this.CreateCalendario({
        employeeID: this.currentUser.EmployeeId,
        calendarioTitle: this.calendarForm.title,
        DirectionID: this.DirectionID,
        TypeStrategic: this.valueEstrategic,
        CompanyID: this.CompanyID,
        EmployeeResponsable: this.employeeIdResponsable,
        PerspectiveID: this.valuePerspective
      });
      if (calendarCrreationResp.status === 200) {
        this.NotifyCalendarCreation(calendarCrreationResp.data);
      } else {
        this.NotifyCalendarCreationFailed();
      }
      this.closeCalendarDialog();
      this.loading = false;
      this.disableBtn = false;
    },
    NotifyCalendarCreation(data) {
      this.$notify({
        title: "Creacion del calendario confirmada",
        message: `Se creo el calendario ${data.Title}, \nCon el Objetivo #${data.IdObjective}`,
        type: "success"
      });
    },
    NotifyCalendarCreationFailed() {
      this.$notify.error({
        title: "Error al crear el Calendario",
        message: "La creacion del calendario Fallo"
      });
    },
    openShareDrawer() {
      if (this.userCanEditCalendar || this.watchingSubordinatesCalendars) {
        this.openDrawer = true;
      } else {
        this.$message.error("No tiene permiso para compartir este calendario");
      }
    },
    handleCloseDrawer() {
      this.openDrawer = false;
    },
    openCalendarDeleteDialog() {
      this.calendarDeleteDialogVisible = true;
    },
    closeCalendarDeleteDialog() {
      this.calendarDeleteDialogVisible = false;
    },
    async handleDeleteCalendar() {
      try {
        this.loading = true;
        let result = await this.DeleteCalendario({
          CalendarID: this.currentChosenCalendarID,
          EmployeeID: this.currentUser.EmployeeId
        });

        if (result.Succeded) {
          this.$message.success("Calendario eliminado exitosamente");
        } else if (result.CantRemovePersonal) {
          this.$message.error("No puede eliminar un calendario personal");
        } else if (result.BelongsToSomeoneElse) {
          this.$message.error("Este calendario fue creado por otra persona");
        }

        await this.getAllCalendarsForEmployee({
          employeeID: this.employeeId,
          DirectionID: this.DirectionID,
          CompanyID: this.CompanyID
        });
        // this.setPersonalCalendarAsCurrentlyChosen();
      } catch {
        this.loading = false;
        this.closeCalendarDeleteDialog();
      } finally {
        this.loading = false;
        this.closeCalendarDeleteDialog();
      }
    },
    async getAgendaByEmployee() {
      // When the Super User changes the employee in the dropdown, it will make an API call to return calendars belonging to the new employee
      // Prevents this from firing on the first change when the page loads. This was causing Events and Tasks to be initialized again after "Created" changed the employee ID
      // Prevents error when selection is cleared

      // Get UserID with the EmployeeID
      const newUserApiCall = await this.$http.get(
        "/api/Employees/" + this.employeeId
      );
      const newUserId = newUserApiCall.data.UserID;
      this.userId = newUserId;

      if (this.currentChosenCalendarID) {
        await this.GetCalendario({
          calendarioID: this.currentChosenCalendarID,
          agendaType: this.agendaType,
          employeeId: this.employeeId
        });
      }
      this.DirectionID = this.$store.state.user.user.DireccionID;
      this.CompanyID = this.$store.state.user.user.CompanySelected;
      await this.getAllCalendarsForEmployee({
        employeeID: this.employeeId,
        DirectionID: this.DirectionID,
        CompanyID: this.CompanyID
      });
      this.currentChosenCalendarID = this.firstCalendar;
    },
    handleChangeDirectionFilter(directionId) {
      this.DirectionFilter = directionId;
      // actualizar lista de departamentos para la gerencia seleccionada
      this.getDepartamentByDirecion(directionId);
      this.loadEmployees();
    },
    handleChangeDeparmentFilter(departmentId) {
      this.DepartamentFilter = departmentId;
      this.loadEmployees();
    },
    getDepartamentByDirecion(directionId) {
      const dirId = directionId || this.DirectionFilter || this.DirectionID;
      if (!dirId) {
        this.DepartamentList = [];
        return;
      }
      this.$http
        .get("/api/Directions/DepartmentByDirecctionID", {
          params: {
            DirecctionId: dirId
          }
        })
        .then((resp) => {
          this.DepartamentList = resp.data || [];
        })
        .catch((error) => {
          console.error("Error obteniendo departamentos por gerencia:", error);
          this.DepartamentList = [];
        });
    }
  },
  watch: {
    currentChosenCalendarID: async function (newCalendarID) {
      if (newCalendarID) {
        await this.GetCalendario({
          calendarioID: newCalendarID,
          agendaType: this.agendaType,
          employeeId: this.employeeId
        });
        if (this.calendarIsPersonal) {
          // If the calendar is personal, get the Tasks of the owner of that calendar
          let calendarCreator = this.listOfCalendarsForUser.find(
            (cal) => cal.ID == newCalendarID
          ).CreatedBy;
          // await this.initTasks(calendarCreator);
          await this.initTasksGantt(calendarCreator);
        }
      }
    },
    agendaType: async function (newAgendaType) {
      await this.GetCalendario({
        calendarioID: this.currentChosenCalendarID,
        agendaType: newAgendaType,
        employeeId: this.employeeId
      });
    }
  }
};
</script>

<style scoped>
.fc-event-resizer.fc-event-resizer-end {
  /* Disables resizing in Week and Day view */
  display: none !important;
}
.fc .fc-col-header-cell-cushion {
  color: #403d3d;
}
.fc .fc-daygrid-day-number {
  color: #403d3d;
}
.fc-daygrid-dot-event .fc-event-title {
  color: #403d3d;
}
.fc .fc-button {
  color: #403d3d !important;
  border-color: #403d3d !important;
}
.fc .fc-button-active {
  color: white !important;
}
.legendColor {
  width: 200px;
  text-align: center;
  color: white;
}
.filterMenuRow {
  margin-top: 10px;
  padding-top: 10px;
  margin-bottom: 0%;
  padding-bottom: 0%;
}
</style>
